import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PlanSelectionComponent } from './plan-selection/plan-selection.component';
//import { PlanService } from './shared/plan-data.service';
import { MainPageLogicComponent } from './main-page-logic/main-page-logic.component';
import { FormPaymentPage } from './main-page-logic/forms/form-payment/form-payment.component';
import { FormContainerComponent } from './main-page-logic/forms/form-container/form-container.component';
import { FormTextBoxComponent } from './main-page-logic/forms/form-textBox/form-textBox.component';
import { FormContactInfoComponent } from './main-page-logic/forms/form-contact-info/form-contact-info.component';
import { FormItemSelectComponent } from './main-page-logic/forms/form-button-item-select/form-item-select.component';
import { FormItemSingleSelectComponent } from './main-page-logic/forms/form-button-item-single-select/form-item-single-select.component';
import { FormItemSelectSimplifiedComponent } from './main-page-logic/forms/form-button-item-select-simplified/form-item-select-simplified.component';
import { ContractCompletionPage } from './confirmation-page/confirmation-page.component';
import { MediaPlanSelectionComponent } from './media-plan-selection/media-plan-selection.component';

const routes: Routes = [
  
  {path: '', redirectTo: '/planselection', pathMatch: 'full'},
  {path: 'plans', component: PlanSelectionComponent},
  {path: 'plans/:planId', component: PlanSelectionComponent},
  {path: 'planselection', component: MediaPlanSelectionComponent},
  
  {path: 'signup',
   component: MainPageLogicComponent,
   children:[
    {path: '', redirectTo: 'contact', pathMatch: 'full'}, //default redirect -AG
    {path: 'contact', component: FormContactInfoComponent },
    {path: 'children', component: FormItemSelectComponent },
    {path: 'options1', component: FormItemSelectSimplifiedComponent },
    {path: 'options2', component: FormItemSelectSimplifiedComponent },
    {path: 'houseSize', component: FormItemSingleSelectComponent },
    {path: 'overview', component: FormTextBoxComponent },
    {path: 'checkout', component: FormPaymentPage}
   ]
   
  },
  {path: 'purchaseConfirmed', component: ContractCompletionPage},
  {path: 'contact',   redirectTo: '/signup/contact',    pathMatch: 'full'},
  {path: 'children',  redirectTo: '/signup/children',   pathMatch: 'full'},
  {path: 'options1',  redirectTo: '/signup/options1',   pathMatch: 'full'},
  {path: 'options2',  redirectTo: '/signup/options2',   pathMatch: 'full'},
  {path: 'houseSize',  redirectTo: '/signup/houseSize',   pathMatch: 'full'},
  {path: 'overview',  redirectTo: '/signup/overview',   pathMatch: 'full'},
  {path: 'checkout',  redirectTo: '/signup/checkout',   pathMatch: 'full'},


  {path: '**', redirectTo: '/planselection', pathMatch: 'full'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule { 

  
}
